import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_BASE_URL as BASE_URL } from '@/environments/environment';
import { Product } from 'sham-components/shared/models';

export interface PublicStoreInfo {
  sellerId: string;
  storeName: string;
  storeSlug: string;
  storeLogoUrl: string | null;
  joinedDate: string;
  totalProductsCount: number;
}

export interface SellerStoreProduct {
  id: string;
  slug: string;
  name: string;
  thumbnailUrl: string | null;
  displayPrice: number;
  currency: string;
  onSale: boolean;
  regularPrice: number;
  salePrice: number | null;
}

export interface StoreProductsResponse {
  items: SellerStoreProduct[];
  page: number;
  pageSize: number;
  totalCount: number;
}

export interface SellerReviewsParams {
  sellerId: string;
  page: number;
  pageSize: number;
}

export interface PublicSellerReviewDto {
  storeReviewId: string;
  sellerId: string;
  rating: number;
  text: string | null;
  customerDisplayName: string;
  createdAtUtc: string;
  lastApprovedAtUtc: string | null;
}

export interface PublicSellerReviewsResponse {
  items: PublicSellerReviewDto[];
  page: number;
  pageSize: number;
  totalCount: number;
}

export interface PublicSellerReviewsSummaryDto {
  sellerId: string;
  approvedPublicReviewCount: number;
  averageRating: number;
  rating1Count: number;
  rating2Count: number;
  rating3Count: number;
  rating4Count: number;
  rating5Count: number;
}

@Injectable({
  providedIn: 'root',
})
export class SellerProfileApi {
  constructor(private readonly http: HttpClient) {}

  /**
   */
  getStoreInfo(sellerId: string) {
    return this.http.get<PublicStoreInfo>(
      `${BASE_URL}/api/v1/public/seller-stores/${sellerId}`,
    );
  }

  getSellerReviews({ sellerId, page = 1, pageSize = 10 }: SellerReviewsParams) {
    return this.http.get<PublicSellerReviewsResponse>(
      `${BASE_URL}/api/v1/public/seller-stores/${sellerId}/reviews`,
      {
        params: {
          page,
          pageSize,
        },
      },
    );
  }

  getSellerReviewsSummary(sellerId: string) {
    return this.http.get<PublicSellerReviewsSummaryDto>(
      `${BASE_URL}/api/v1/public/seller-stores/${sellerId}/reviews/summary`,
    );
  }
  /**
   */
  getStoreProducts(
    sellerId: string,
    page = 1,
    pageSize = 20,
    sort?: string,
    lang?: string,
  ) {
    return this.http.get<StoreProductsResponse>(
      `${BASE_URL}/api/v1/public/seller-stores/${sellerId}/products`,
      {
        params: {
          page,
          pageSize,
          ...(sort ? { sort } : {}),
          ...(lang ? { lang } : {}),
        },
      },
    );
  }
}
